import { useCallback } from 'react';
import googleAnalyticsService from '../services/googleAnalyticsService';

/**
 * Custom hook for Google Analytics tracking
 * Provides easy access to GA tracking methods throughout the app
 */
export const useGoogleAnalytics = () => {
  // Page tracking
  const trackPageView = useCallback((path, title) => {
    googleAnalyticsService.trackPageView(path, title);
  }, []);

  // Event tracking
  const trackEvent = useCallback((action, parameters) => {
    googleAnalyticsService.trackEvent(action, parameters);
  }, []);

  // Business-specific tracking methods
  const trackRegistration = useCallback((data) => {
    googleAnalyticsService.trackRegistration(data);
  }, []);

  const trackLogin = useCallback((data) => {
    googleAnalyticsService.trackLogin(data);
  }, []);

  const trackWebsiteAnalysis = useCallback((data) => {
    googleAnalyticsService.trackWebsiteAnalysis(data);
  }, []);

  const trackWebsiteAdded = useCallback((data) => {
    googleAnalyticsService.trackWebsiteAdded(data);
  }, []);

  const trackSupportTicket = useCallback((data) => {
    googleAnalyticsService.trackSupportTicket(data);
  }, []);

  const trackPurchase = useCallback((value, currency, data) => {
    googleAnalyticsService.trackPurchase(value, currency, data);
  }, []);

  const trackSubscription = useCallback((data) => {
    googleAnalyticsService.trackSubscription(data);
  }, []);

  const trackCustomEvent = useCallback((eventName, data) => {
    googleAnalyticsService.trackCustomEvent(eventName, data);
  }, []);

  const setUserProperties = useCallback((properties) => {
    googleAnalyticsService.setUserProperties(properties);
  }, []);

  return {
    trackPageView,
    trackEvent,
    trackRegistration,
    trackLogin,
    trackWebsiteAnalysis,
    trackWebsiteAdded,
    trackSupportTicket,
    trackPurchase,
    trackSubscription,
    trackCustomEvent,
    setUserProperties
  };
};
